module.exports = __webpack_public_path__ + "img/article-doc-3.ef8dac67.png";